export default __webpack_public_path__ + "static/media/network_services.17287dbf.svg";